import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IconArrowUpRight } from "@tabler/icons-react";
import exploreQuickTourIcon from "@/assets/dashboard/explore-quick-tour.png";
import styles from "./ExploreMaatraBanner.module.css";

const ExploreMaatraBanner: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={styles.banner}
      onClick={() => navigate("/explore-maatra")}
      data-explore-maatra-banner
    >
      <div className={styles.left}>
        <div className={styles.iconWrapper}>
          <img src={exploreQuickTourIcon} alt="" className={styles.icon} />
        </div>
        <div className={styles.text}>
          <span className={styles.title}>{t("dashboard.exploreCta")}</span>
          <span className={styles.subtitle}>
            {t("dashboard.exploreSection.quickTour")}
          </span>
        </div>
      </div>
      <div className={styles.arrowWrapper}>
        <IconArrowUpRight size={24} color="#8764BB" />
      </div>
    </button>
  );
};

export default ExploreMaatraBanner;
